import { auth } from "../type";
import {
  readSession,
  toUserString,
  toWalletString,
} from "../../utils/storedUser";

// Read ONCE, before the state literal below, so the cleanup a corrupt user
// triggers (which also clears the token) cannot race the key order here.
const session = readSession();

const initialState = {
  token: session.token,
  // Sanitized: a corrupt leftover (e.g. the literal string "undefined") is
  // dropped rather than seeded into the store, where it would make every
  // `JSON.parse(user)` call site throw.
  user: session.user,
  rpc: undefined,
  // Same sanitized treatment as `user`: the wallet blob was written with the
  // same JSON.stringify(undefined) bug and is parsed raw in Header.
  wallet: session.wallet,
  authError: "",
  forgetPasswordOTP: false,
  verifiedUser: false,
  registerOTPSent: false,
  resendOTP: false,
  resetPasswordSuccess: false,
  loginOTP: false,
  loginResponse: false,
  loginLoader: false,
  alacrityUsername: localStorage.getItem("alacrityName") || "",
  mnemonic: localStorage.getItem("mnemonic") || "",
  privateKey: localStorage.getItem("privateKey") || "",
  publicKey: localStorage.getItem("publicKey") || "",
  isMnemonicsPopUpOpen: true,
  custodianLimits: {
    tiedLimit: 0,
    freeLimit: 0,
    businessLimit: 0
  }
};

const Authentication = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case auth.SET_RPC: {
      return {
        ...state,
        rpc: payload,
      };
    }
    case auth.SET_AUTH_TOKEN: {
      return {
        ...state,
        token: payload,
      };
    }
    case auth.SET_USER_DETAILS: {
      return {
        ...state,
        // Normalized in ONE place: callers pass `JSON.stringify(res?.data?.user)`,
        // which is the VALUE undefined whenever that field is missing. Storing it
        // raw put a non-JSON value in front of every `JSON.parse(user)` reader.
        user: toUserString(payload),
      };
    }

    case auth.SET_LIMITS: {
      return {
        ...state,
        custodianLimits: payload,
      };
    }

    case auth.SET_WALLET_DETAILS: {
      return {
        ...state,
        // Callers pass `JSON.stringify(res?.data?.data?.userWallet)`, which is
        // the value undefined when that field is missing. Normalize once here.
        wallet: toWalletString(payload),
      };
    }

    case auth.SET_AUTH_ERROR: {
      return {
        ...state,
        authError: payload,
      };
    }

    case auth.SET_PASSWORD_OTP: {
      return {
        ...state,
        forgetPasswordOTP: payload,
      };
    }

    case auth.SET_USER_STATUS: {
      return {
        ...state,
        verifiedUser: payload,
      };
    }

    case auth.SET_REGISTER_OTP_SENT: {
      return {
        ...state,
        registerOTPSent: payload,
      };
    }

    case auth.SET_RESEND_OTP: {
      return {
        ...state,
        resendOTP: payload,
      };
    }

    case auth.SET_RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        resetPasswordSuccess: payload,
      };
    }

    case auth.SET_LOGIN_OTP: {
      return {
        ...state,
        loginOTP: payload,
      };
    }

    case auth.SET_LOGIN_RESPONSE: {
      return {
        ...state,
        loginResponse: payload,
      };
    }

    case auth.SET_LOGIN_LOADER: {
      return {
        ...state,
        loginLoader: payload,
      };
    }

    case auth.SET_ACCOUNT_DETAILS: {
      return {
        ...state,
        alacrityUsername: payload.alacrityUsername,
        mnemonic: payload.mnemonic,
        privateKey: payload.privateKey,
        publicKey: payload.publicKey,
      };
    }
    case auth.OPEN_MNEMONICS_POPUP: {
      return {
        ...state,
        isMnemonicsPopUpOpen: true,
      };
    }

    case auth.CLOSE_MNEMONICS_POPUP: {
      return {
        ...state,
        isMnemonicsPopUpOpen: false,
      };
    }
    case auth.RESET_AUTH_STATE: {
      return {
        ...initialState,
        token: "",
        user: "",
      };
    }

    default: {
      return state;
    }
  }
};

export default Authentication;